import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/landingpage.css';
import { Link } from 'react-router-dom';

function Landingpage() {
  window.scrollTo(0, 0);

  const news = [
    {
      date: '26.02.2026',
      title: '10. Arbeitstagung der AG Leseverstehen',
      link: '/news'
    },
    {
      date: '26.02.2026',
      title: 'Beiträge in Frontiers',
      link: 'https://www.frontiersin.org/journals/education/articles/10.3389/feduc.2026.1702406/full',
      external: true
    },
    {
      date: '10.12.2025',
      title: 'Praxiserprobung an der Nordschule',
      link: '/news'
    },
  ];

  return (
    <div className="bg-light">
      <Navigation />

      <div className="position-relative text-white" style={{ backgroundImage: 'url("/material/Hintergrund.jpg")', backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '100vh' }}>
        <div
            className="container h-100 d-flex flex-column justify-content-center"
            style={{ paddingTop: '8rem' }}
            >
          <div className="row">
            <div className="col-md-8 text-center text-md-start mb-4 mb-md-0">
              <h1 className="display-4 fw-bold text-shadow">Lesedidaktik und Lesediagnostik</h1>
              <h2 className="fs-2 text-shadow">Schreibdidaktik und Schreiben mit KI</h2>
            </div>

            {/* Desktop: rechtsbündig / Mobile: unten in Reihe */}
            <div className="col-md-4 d-none d-md-flex flex-column justify-content-center text-end" style={{ marginTop: '6rem',  marginRight: '-5rem', paddingTop: '4rem' }}>
              {news.map((item, index) => (
                item.external ? (
                  <a key={index} href={item.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                    <div className="mb-3">
                      <div className="text-muted small">{item.date}</div>
                      <div className="text-white fw-semibold border-end border-2 pe-2">{item.title}</div>
                    </div>
                  </a>
                ) : (
                  <Link key={index} to={item.link} className="text-decoration-none">
                    <div className="mb-3">
                      <div className="text-muted small">{item.date}</div>
                      <div className="text-white fw-semibold border-end border-2 pe-2">{item.title}</div>
                    </div>
                  </Link>
                )
              ))}
            </div>
          </div>

          {/* Mobile-Version unten im Banner */}
          <div className="d-md-none" style={{ marginTop: '6rem', paddingTop: '8rem' }}>
            <div className="d-flex justify-content-around bg-dark bg-opacity-50 p-2 rounded">
              {news.map((item, index) => (
                item.external ? (
                  <a key={index} href={item.link} target="_blank" rel="noopener noreferrer" className="text-white text-center small text-decoration-none px-2">
                    <div className="small text-info">{item.date}</div>
                    <div>{item.title}</div>
                  </a>
                ) : (
                  <Link key={index} to={item.link} className="text-white text-center small text-decoration-none px-2">
                    <div className="small text-info">{item.date}</div>
                    <div>{item.title}</div>
                  </Link>
                )
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landingpage;
